const DesktopRecordviewReducer = (draft, { type, payload }) => {
  switch (type) {
    case "SET_CONFIG":
      return payload;
    case "PRE_FILTERS":
      draft.config.layout.pre_filters = payload.prefilter;
      draft.config.layout.prefilters_joined_by = payload.prefilters_joined_by;
      break;
    case "OWNER_PRE_FILTERS":
      draft.config.layout.owner_pre_filters = payload;
      break;
    case "DEFAULT_SORT":
      draft.config.layout.default_sort = payload;
      break;
    case "INFO_TAG":
      draft.info_tag = payload;
      break;
    case "DESCRIPTION":
      draft.description = payload;
      break;
    case "BLOCK_TILES":
      draft.config.layout.tiles = payload;
      break;
    case "BLOCK_CHARTS":
      draft.config.layout.charts = payload;
      break;
    case "TITLE":
      draft.config.layout.title = payload;
      break;
    case "UPDATE_ACTION_PERMISSIONS":
      draft.config.layout[payload.name] = payload.value;
      break;
    case "ACCESS_TEMPLATES":
      draft.access_templates = payload;
      break;
    case "UPDATE_ONSCREEN_FILTERS":
      draft.config.layout.onscreen_filters = payload;
      break;
    case "ADD_ONSCREEN_FILTER":
      draft.config.layout.onscreen_filters.push(payload);
      break;
    case "DELETE_ONSCREEN_FILTER":
      draft.config.layout.onscreen_filters.splice(payload, 1);
      break;
    case "UPDATE_MULTI_SELECT_CUSTOM_ACTIONS":
      draft.config.layout.multi_select_custom_actions = payload;
      break;
    case "UPDATE_SINGLE_ONSCREEN_FILTER":
      draft.config.layout.onscreen_filters[payload.index] = payload.data;
      break;
    case "ADD_COLUMN":
      if (payload.index === draft.config.layout.columns.length) {
        draft.config.layout.columns.push(payload.value);
      } else {
        draft.config.layout.columns.splice(payload.index + 1, 0, payload.value);
      }
      break;
    case "CHANGE_COLUMN":
      draft.config.layout.columns[payload.index] = payload.value;
      break;
    case "DELETE_COLUMN":
      draft.config.layout.columns.splice(payload.index, 1);
      break;
    case "SORT_COLUMN":
      draft.config.layout.columns = payload.allColumns;
      break;
    case "EDIT_COLUMN":
      draft.config.layout.columns[payload.index] = payload.value;
      break;
    case "EDIT_BUTTON_CUSTOM_COLUMN":
      draft.config.layout.columns[payload.index].config[payload.elementIndex] = payload.value;
      break;
    case "DELETE_BUTTON_CUSTOM_COLUMN":
      draft.config.layout.columns[payload.index].config.splice(payload.elementIndex, 1);
      break;
    case "ON_ROW_ACTION":
      draft.config.layout.on_row_action = payload;
      break;
    case "UPDATE_NUMBER_OF_ROWS":
      draft.config.layout.catalog.catalog_in_row = payload.value;
      break;
    case "EDIT_RECORDSET_LAYOUT":
      let column = draft.config.layout.columns[payload.index];
      if (!column.layout_config) {
        column.layout_config = {};
      }
      column.layout_config.layouts = payload.value;
      break;
    case "DATA_LIMIT":
      draft.config.layout.data_limit = payload.value;
      break;
    case "COLUMN_PRE_FILTERS":
      draft.config.layout.column_pre_filters = payload.value;
      break;
    case "HIDDEN_COLUMNS":
      draft.config.layout.hidden_columns = payload;
      break;
    case "UPDATE_EMBEDDED_DV_ID":
      draft.config.layout.catalog.embedded_detailview.detailview_id = payload;
      break;
    case "RECORDSVIEW_SIZE":
      if (!draft.recordsview_settings) {
        draft.recordsview_settings = {};
      }
      draft.recordsview_settings.size = payload;
      break;
    case "UPDATE_POSITION_BLOCK_CONFIG":
      draft.position_block_config = payload;
      break;
    default:
      break;
  }
};
export default DesktopRecordviewReducer;
